module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "advantage-addition-wrapper"
  }, [_c('div', {
    staticClass: "advantage-addition"
  }, [_c('img', {
    staticClass: "delete-icon",
    attrs: {
      "src": "/static/img/icons/delete.svg"
    },
    on: {
      "click": function($event) {
        return _vm.deleteAdvantage(_vm.advantage.id)
      }
    }
  }), _vm._v(" "), _c('b-field', [_c('b-input', {
    attrs: {
      "placeholder": "Заголовок"
    },
    on: {
      "change": function($event) {
        return _vm.updateAdvantage(_vm.advantage)
      }
    },
    model: {
      value: (_vm.advantage.title),
      callback: function($$v) {
        _vm.$set(_vm.advantage, "title", $$v)
      },
      expression: "advantage.title"
    }
  })], 1), _vm._v(" "), _c('b-field', [_c('b-input', {
    attrs: {
      "placeholder": "Текст",
      "type": "textarea"
    },
    on: {
      "change": function($event) {
        return _vm.updateAdvantage(_vm.advantage)
      }
    },
    model: {
      value: (_vm.advantage.description),
      callback: function($$v) {
        _vm.$set(_vm.advantage, "description", $$v)
      },
      expression: "advantage.description"
    }
  })], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4e19ab48"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Services/Advantage.vue
// module id = 945
// module chunks = 0